import * as React from "react";
import {
  Avatar,
  Grid
} from "@mui/material";
import {Title5} from "../../../domains/common/components/Typography";

export function Responsible({value}) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}><Title5 title="Ответственный"/></Grid>
      <Grid item xs={0.2}></Grid>
      <Grid item xs={1.7}><Avatar sx={{ width: 65, height: 65 }} src={value?.photo}/></Grid>
      <Grid item xs={10}>
        <Grid container>
          <Grid item xs={12} sx={{fontSize: 16}}>{value?.fio}</Grid>
          {value?.phone ? <Grid item xs={12} sx={{fontWeight: 'light', fontSize: 16}}>{value?.phone}</Grid> : void 0}
          <Grid item xs={12} sx={{fontWeight: 'light', fontSize: 16}}>{value?.email}</Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

